const CATALOGUE=Object.freeze([
  Object.freeze({key:'wooden_smokehouse',labels:Object.freeze({pl:'Wędzarnia drewniana',en:'Wooden smokehouse'})}),
  Object.freeze({key:'masonry_smokehouse',labels:Object.freeze({pl:'Wędzarnia murowana',en:'Masonry smokehouse'})}),
  Object.freeze({key:'cabinet_electric',labels:Object.freeze({pl:'Wędzarnia elektryczna szafkowa',en:'Electric cabinet smoker'})}),
  Object.freeze({key:'cabinet_gas',labels:Object.freeze({pl:'Wędzarnia gazowa szafkowa',en:'Gas cabinet smoker'})}),
  Object.freeze({key:'cabinet_charcoal',labels:Object.freeze({pl:'Wędzarnia węglowa szafkowa',en:'Charcoal cabinet smoker'})}),
  Object.freeze({key:'offset_smoker',labels:Object.freeze({pl:'Wędzarnia typu offset',en:'Offset smoker'})}),
  Object.freeze({key:'drum_smoker',labels:Object.freeze({pl:'Wędzarnia beczkowa',en:'Drum smoker'})}),
  Object.freeze({key:'pellet_smoker',labels:Object.freeze({pl:'Wędzarnia pelletowa',en:'Pellet smoker'})}),
  Object.freeze({key:'kettle_grill',labels:Object.freeze({pl:'Grill kulisty używany do wędzenia',en:'Kettle grill used for smoking'})}),
  Object.freeze({key:'kamado',labels:Object.freeze({pl:'Grill ceramiczny Kamado',en:'Kamado ceramic grill'})}),
  Object.freeze({key:'custom',labels:Object.freeze({pl:'Inna / własna konstrukcja',en:'Other / custom build'})})
]);

const BY_KEY=new Map(CATALOGUE.map(item=>[item.key,item]));

function normaliseLocale(value){
  const locale=String(value||'pl').trim().toLowerCase();
  return locale.startsWith('en')?'en':'pl';
}

function normaliseKey(value){
  const key=String(value||'').trim().toLowerCase();
  return /^[a-z][a-z0-9_]{1,63}$/.test(key)?key:null;
}

function present(item,locale){
  const lang=normaliseLocale(locale);
  return Object.freeze({
    key:item.key,
    label:item.labels[lang]||item.labels.pl,
    known:true
  });
}

export function listSmokerTypes({locale='pl'}={}){
  return Object.freeze(CATALOGUE.map(item=>present(item,locale)));
}

export function resolveSmokerType(value,{locale='pl'}={}){
  const key=normaliseKey(value);
  if(!key)return null;
  const item=BY_KEY.get(key);
  if(item)return present(item,locale);

  const lang=normaliseLocale(locale);
  return Object.freeze({
    key,
    label:lang==='en'?'Other / unknown type':'Inny / nieznany typ',
    known:false
  });
}

export function isKnownSmokerType(value){
  const key=normaliseKey(value);
  return Boolean(key&&BY_KEY.has(key));
}
